import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AdsOrganization } from './ads-organization';

@Injectable({
  providedIn: 'root'
})
export class OrganizationService {

  constructor(
    private httpClient: HttpClient
  ) { }

  public get(): Observable<AdsOrganization> {
    return this.httpClient.get<AdsOrganization>('/api/media/organization')
  }

  public save(data: object): Observable<AdsOrganization> {
    return this.httpClient.post<AdsOrganization>('/api/media/organization', data)
  }
}
